import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "impx-slide-container style1 resto" }
const _hoisted_2 = { class: "impx-slideshow-fw" }
const _hoisted_3 = { class: "impx-hero-resto uk-position-relative uk-background-fixed uk-background-center-center uk-height-1-1" }
const _hoisted_4 = { class: "uk-container" }
const _hoisted_5 = { class: "uk-grid uk-flex uk-flex-center uk-flex-middle" }
const _hoisted_6 = { class: "uk-width-1-2@xl uk-width-1-2@l uk-width-1-1@m uk-width-1-1@s uk-position-center uk-margin-large-top" }
const _hoisted_7 = { class: "impx-slide-fw-caption resto-caption uk-position-relative uk-position-z-index uk-text-center uk-light" }
const _hoisted_8 = { class: "impx-text-shadow" }
const _hoisted_9 = { class: "uk-margin-remove impx-text-shadow uk-text-lead" }
const _hoisted_10 = { class: "uk-padding uk-padding-remove-horizontal uk-padding-remove-bottom bg-color-gray pattern-1 impx-resto-badge" }
const _hoisted_11 = { class: "uk-container" }
const _hoisted_12 = { class: "uk-grid" }
const _hoisted_13 = { class: "uk-width-2-5@xl uk-width-2-5@l uk-width-2-5@m uk-width-1-1@s uk-vertical-align-bottom uk-position-relative uk-position-z-index impx-negative-top xxlarge" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "uk-width-3-5@xl uk-width-3-5@l uk-width-3-5@m uk-width-1-1@s impx-intro resto" }
const _hoisted_16 = { class: "impx-text-large uk-margin-bottom" }
const _hoisted_17 = { class: "impx-list-inline impx-hours" }
const _hoisted_18 = { class: "impx-text-csa" }
const _hoisted_19 = { class: "uk-padding uk-margin-bottom resto-feat uk-padding-remove-horizontal" }
const _hoisted_20 = { class: "uk-container" }
const _hoisted_21 = { "data-uk-grid": "" }
const _hoisted_22 = { class: "uk-width-2-3@xl uk-width-2-3@l uk-width-1-1@m uk-width-1-1@s uk-margin-top" }
const _hoisted_23 = { class: "impx-intro resto margin-medium" }
const _hoisted_24 = { class: "uk-margin-medium-bottom impx-text-large" }
const _hoisted_25 = {
  class: "uk-child-width-1-2@xl uk-child-width-1-2@l uk-child-width-1-2@m uk-child-width-1-2@s",
  "data-uk-grid": ""
}
const _hoisted_26 = { "data-uk-grid": "" }
const _hoisted_27 = { class: "uk-width-1-3@xl uk-width-1-3@l uk-width-1-3@m uk-width-1-1@s" }
const _hoisted_28 = { class: "uk-position-relative" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "uk-width-2-3@xl uk-width-2-3@l uk-width-2-3@m uk-width-1-1@s" }
const _hoisted_31 = { class: "uk-margin-remove-bottom" }
const _hoisted_32 = { class: "uk-margin-small-top uk-margin-remove-bottom" }



export default /*@__PURE__*/_defineComponent({
  __name: 'RestaurantHeading',
  props: {
  appointment: {},
  restaurantHero:{},
  presentation:{}
},
  setup(__props) {

const special_offer = [
    './images/restaurant/intro-img-1.jpg',
    './images/restaurant/intro-img-2.jpg',
    './images/restaurant/intro-img-3.jpg',
    './images/restaurant/intro-img-4.jpg',
]
const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "impx-overlay dark" }, null, -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h1", _hoisted_8, _toDisplayString(props.restaurantHero?.title??''), 1),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(props.restaurantHero?.subtitle), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "uk-margin" }, [
                    _createElementVNode("i", { class: "fa fa-coffee impx-slide-icon impx-text-white" }),
                    _createElementVNode("i", { class: "fa fa-cutlery impx-slide-icon impx-text-white" }),
                    _createElementVNode("i", { class: "fa fa-glass impx-slide-icon impx-text-white" })
                  ], -1))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("img", {
              src: __props.appointment?.presentation[0]?.heroImage?.url,
              alt: "Restaurant",
              class: "img-resto-intro uk-align-center"
            }, null, 8, _hoisted_14)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h3", null, _toDisplayString(__props.appointment?.presentation[0]?.title??''), 1),
            _createElementVNode("p", _hoisted_16, _toDisplayString(__props.appointment?.presentation[0]?.content??''), 1),
            _createElementVNode("ul", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.appointment?.AppointmentMenu, (menuHour, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _cache[2] || (_cache[2] = _createElementVNode("i", { class: "{{menuHour?.icon}} impx-text-csa" }, null, -1)),
                  _createElementVNode("strong", _hoisted_18, _toDisplayString(menuHour?.title), 1),
                  _createTextVNode(" " + _toDisplayString(menuHour?.hour), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("h3", null, _toDisplayString(__props.presentation?.title??''), 1),
              _createElementVNode("p", _hoisted_24, _toDisplayString(__props.presentation?.subtitle??''), 1)
            ]),
            _createElementVNode("ul", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.presentation?.presentationItems, (appointKeyPoint, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "resto-feat-item",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("img", {
                          src: special_offer[0],
                          alt: "resort",
                          class: "uk-border-circle"
                        }, null, 8, _hoisted_29),
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "impx-overlay light overlay-outline padding-medium" }, null, -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("h5", _hoisted_31, _toDisplayString(appointKeyPoint?.title), 1),
                      _createElementVNode("p", _hoisted_32, _toDisplayString(appointKeyPoint?.content), 1)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "uk-width-1-3@xl uk-width-1-3@l uk-width-1-1@m" }, [
            _createElementVNode("div", { class: "impx-img-stacked uk-padding-remove-horizontal" }, [
              _createElementVNode("img", {
                src: '../images/gallery/price-bg.png',
                alt: "cité sainte augustine resto",
                class: ""
              }),
              _createElementVNode("img", {
                src: '../images/heading/room-3.jpg',
                alt: "csa restaurant",
                class: ""
              })
            ])
          ], -1))
        ])
      ])
    ])
  ], 64))
}
}

})